export default "__VITE_ASSET__DajxgCdb__"